module.exports = __webpack_public_path__ + "media/icons/naped-tyl-blue-6622a80e.png";